import { Fragment } from "react";

export function InfoPanel({ count, totals }: { count: number; totals?: { label: string; value: string }[] }) {
  return (
    <aside className="box card" aria-label="Informações">
      <div className="card-header fw-semibold">Informações</div>
      <dl className="card-body mb-0">
        <dt className="small text-muted">Registros</dt>
        <dd className="fs-4 mb-2">{count}</dd>
        {totals?.map((t) => (
          <Fragment key={t.label}>
            <dt className="small text-muted">{t.label}</dt>
            <dd className="fs-5 num">{t.value}</dd>
          </Fragment>
        ))}
      </dl>
    </aside>
  );
}
